var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-logo-mobile-header-top',{staticClass:"logo-mobile-top",attrs:{"href":_vm.route_home}},[_c('img',{attrs:{"src":_vm.logoUrl,"alt":_vm.fantasyName,"loading":"lazy","width":"100","height":"50"}})])}
var staticRenderFns = []

export { render, staticRenderFns }